import script from "./productWhy.vue?vue&type=script&lang=ts&setup=true"
export * from "./productWhy.vue?vue&type=script&lang=ts&setup=true"

import "./productWhy.vue?vue&type=style&index=0&id=2137e10c&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2137e10c"]])

export default __exports__